import React from 'react';
import { useTranslation } from 'react-i18next';
import { HOME_TABS } from './tabs';
import connect from '../utils/connect';
import { Client } from '@app/types/api';
import { Tabs, theme } from '@app/ui';

type NavTabsProps = {
    onTabSelection: (tab: string) => void;
    client: Client;
    selectedTab?: string;
};

const HomeTabs = ({
    client,
    onTabSelection,
    selectedTab = 'OVERVIEW',
}: NavTabsProps) => {
    const { t } = useTranslation('home');
    const [hoveredTab, setHoveredTab] = React.useState(null);

    const onChange = key => {
        onTabSelection(key);
    };

    const {
        token: { colorPrimary },
    } = theme.useToken();

    const items = React.useMemo(() => {
        return Object.values(HOME_TABS)
            .map(({ name, titleKey, permission, icon }) => {
                const isVisible =
                    !permission || client.permissions.includes(permission);
                if (!isVisible) return null;
                const isActive = selectedTab === name;
                const isHovered = hoveredTab === name;

                const iconComponent = React.createElement(icon, {
                    color: isActive || isHovered ? colorPrimary : '#515252',
                    width: 16,
                    height: 16,
                    style: { fontSize: 16 },
                });

                return {
                    key: name,
                    label: (
                        <div
                            onMouseEnter={() => setHoveredTab(name)}
                            onMouseLeave={() => setHoveredTab(null)}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: 12,
                            }}
                        >
                            {iconComponent}
                            {t(titleKey)}
                        </div>
                    ),
                };
            })
            .filter(Boolean);
    }, [client.permissions, selectedTab, hoveredTab, t, colorPrimary]);

    return (
        <div data-test="home-nav-tabs">
            <Tabs activeKey={selectedTab} items={items} onChange={onChange} />
        </div>
    );
};

export default connect(['client'])(HomeTabs);
